import React from 'react';
import { Shield } from 'lucide-react';
import { PoofyPayMark } from './PoofyPayMark';

interface CheckoutShellProps {
  children: React.ReactNode;
}

export const CheckoutShell: React.FC<CheckoutShellProps> = ({ children }) => (
  <div className='min-h-screen flex flex-col' style={{ background: 'var(--pp-bg)' }}>
    {/* Top bar */}
    <header
      className='flex items-center justify-between px-6 py-3 border-b'
      style={{ background: 'var(--pp-surface)', borderColor: 'var(--pp-border)' }}
    >
      <PoofyPayMark size='md' />
      {/* Non-interactive trust indicator (not a button — nothing to click) */}
      <span
        className='inline-flex items-center gap-1.5 text-xs'
        style={{ color: 'var(--pp-text-muted)' }}
      >
        <Shield size={13} strokeWidth={2} />
        Secure
      </span>
    </header>

    {/* Page content */}
    <main className='flex-1 flex flex-col'>
      {children}
    </main>

    {/* Footer */}
    <footer
      className='px-6 py-3 border-t text-xs flex items-center gap-4'
      style={{ borderColor: 'var(--pp-border)', color: 'var(--pp-text-subtle)' }}
    >
      <span>Secure checkout by pay.poofy.ai</span>
      <span>·</span>
      <a
        href='https://poofy.ai/terms'
        target='_blank'
        rel='noopener noreferrer'
        className='hover:underline inline-flex items-center py-3'
      >
        Terms
      </a>
      <a
        href='https://poofy.ai/privacy'
        target='_blank'
        rel='noopener noreferrer'
        className='hover:underline inline-flex items-center py-3'
      >
        Privacy
      </a>
    </footer>
  </div>
);

export default CheckoutShell;
